import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'First name',
    dataIndex: 'firstName',
    key: 'firstName',
  },
  {
    title: 'Last name',
    dataIndex: 'lastName',
    key: 'lastName',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Registration date',
    dataIndex: 'addedAt',
    key: 'addedAt',
    customRender: ({ text }) => dateFormat(text, 'DD-MM-YYYY HH:mm'),
  },
  {
    title: 'Update date',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    customRender: ({ text }) => dateFormat(text, 'DD-MM-YYYY HH:mm'),
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'Company',
    dataIndex: 'companyId',
    key: 'companyId',
  },
  {
    title: 'Deleted',
    dataIndex: 'isDeleted',
    key: 'isDeleted',
  },
  {
    title: 'Actions',
    dataIndex: 'id',
    key: 'id',
    width: '8%',
  },
]);

export default columns;
